module.exports = __webpack_public_path__ + "static/img/p4.b822c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p4.png
// module id = KrPX
// module chunks = 0